
import { extend } from 'vee-validate';
import { 
    required, 
    email,
    numeric 
} from 'vee-validate/dist/rules';


extend('email', email);
extend('required', required);
extend('number', numeric);
extend('double', {
    validate: value => {
        let re = new RegExp('(?:\\d+(?:\\.\\d+)?)$', 'gm');
        let res = re.test(value);
        return res;

    }
})
